const toStringSafe = (value) => {
    if (typeof value === "string")
        return value;
    if (value === null || value === undefined)
        return "";
    return String(value);
};
export const isToolSemanticLogUiEnabled = () => {
    if (typeof window === "undefined") {
        return false;
    }
    return window.__carouselShowToolSemanticLogs === true;
};
const formatSemanticLogEntries = (entries) => {
    const lines = [];
    for (const entry of entries) {
        const stage = toStringSafe(entry.stage).trim() || "stage";
        const message = toStringSafe(entry.message).trim();
        const timestamp = toStringSafe(entry.timestamp).trim();
        const payload = entry.payload;
        let line = `[${stage}] ${message}`.trim();
        if (timestamp) {
            line = `${line} (${timestamp})`;
        }
        if (payload !== undefined) {
            try {
                line += `\n  payload: ${JSON.stringify(payload, null, 2)}`;
            }
            catch {
                line += `\n  payload: ${toStringSafe(payload)}`;
            }
        }
        lines.push(line);
    }
    return lines.join("\n");
};
const extractFromSingleResult = (result) => {
    const semanticLogText = result.semanticLogText;
    if (typeof semanticLogText === "string" && semanticLogText.trim().length > 0) {
        const entries = Array.isArray(result.semanticLog) ? result.semanticLog.length : 0;
        return { text: semanticLogText, entryCount: entries };
    }
    const semanticLog = result.semanticLog;
    if (Array.isArray(semanticLog) && semanticLog.length > 0) {
        return {
            text: formatSemanticLogEntries(semanticLog),
            entryCount: semanticLog.length,
        };
    }
    return null;
};
export const extractToolResultSemanticLog = (result) => {
    if (!isToolSemanticLogUiEnabled()) {
        return null;
    }
    if (!result || typeof result !== "object") {
        return null;
    }
    const topLevel = extractFromSingleResult(result);
    if (topLevel) {
        return topLevel;
    }
    // Handle nested result shapes like readExcel: { results: { readChart: [...] } }
    const nested = result.results;
    if (!nested || typeof nested !== "object") {
        return null;
    }
    const nestedResults = nested;
    const combinedChunks = [];
    let entryCount = 0;
    for (const [bucket, value] of Object.entries(nestedResults)) {
        if (!Array.isArray(value))
            continue;
        for (const item of value) {
            if (!item || typeof item !== "object")
                continue;
            const extracted = extractFromSingleResult(item);
            if (!extracted)
                continue;
            combinedChunks.push(`### ${bucket}\n${extracted.text}`);
            entryCount += extracted.entryCount;
        }
    }
    if (combinedChunks.length === 0) {
        return null;
    }
    return {
        text: combinedChunks.join("\n\n"),
        entryCount,
    };
};
